import { useEffect, useState, useRef } from "react";
import { Feather, Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { authVerifyEmail } from "@/lib/api";
import { authBackgroundStyle } from "@/lib/authBackground";


export default function VerifyEmail() {
    const [status, setStatus] = useState("loading"); // loading | success | error
    const [message, setMessage] = useState("");
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return; // guard against React StrictMode double-invoke
        ran.current = true;
        const token = new URLSearchParams(window.location.search).get("token");
        if (!token) {
            setStatus("error");
            setMessage("This verification link is missing its token.");
            return;
        }
        authVerifyEmail(token)
            .then(() => {
                setStatus("success");
                setTimeout(() => { window.location.href = "/"; }, 1800);
            })
            .catch((err) => {
                setStatus("error");
                const d = err.response?.data?.detail;
                setMessage(typeof d === "string" ? d : "This verification link is invalid or has expired.");
            });
    }, []);

    return (
        <div className="min-h-screen relative text-white flex items-center justify-center p-6"
            style={authBackgroundStyle}>
            <div className="absolute inset-0 bg-black/60" />
            <div className="relative z-10 w-full max-w-md text-center bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-10">
                <div className="flex items-center justify-center gap-2 mb-6">
                    <Feather className="w-5 h-5 text-white/90" />
                    <span className="font-heading text-2xl tracking-tight">Day Dreamer</span>
                </div>
                {status === "loading" && (
                    <div data-testid="verify-loading" className="space-y-3">
                        <Loader2 className="w-8 h-8 animate-spin mx-auto text-white/90" />
                        <p className="text-white/80">Verifying your email…</p>
                    </div>
                )}
                {status === "success" && (
                    <div data-testid="verify-success" className="space-y-3">
                        <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-300" />
                        <h1 className="font-heading text-2xl">Email verified</h1>
                        <p className="text-white/80">Your account is active. Taking you to your desk…</p>
                    </div>
                )}
                {status === "error" && (
                    <div data-testid="verify-error" className="space-y-4">
                        <XCircle className="w-10 h-10 mx-auto text-red-300" />
                        <h1 className="font-heading text-2xl">Verification failed</h1>
                        <p className="text-white/80">{message}</p>
                        <Button data-testid="verify-back-home" onClick={() => { window.location.href = "/"; }}
                            className="rounded-full h-11 px-7 bg-white text-foreground hover:bg-white/90">
                            Back to sign in
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
